<template>
  <div class="row">
    <div class="col-sm-7">
      <ClientGlobalCard
        :client="client"
        :orders="client.orders"
        :sessions="client.sessions"
        :groups="groups"
        @edit="edit"
        @editOrderDescription="editOrderDescription"
        @deleteOrderDescription="deleteOrderDescription"
        @addOrderDescription="addOrderDescription"
      />

      <ClientUrssafCard :client="client" v-if="!client.deletedAt" />
    </div>
    <div class="col-sm-5">
      <ClientStatusCard
        :clientData="client"
        :orders="client.orders"
        :disabled-dates="disabledDates"
        @edit="edit"
        @reload="reload"
      />

      <ClientCommercialCard
        :client="client"
        :commercials="commercials"
        :disabled-dates="disabledDates"
        @edit-notes="editNotes"
      />

      <ClientAxonautRelation :clientData="client" v-if="!client.deletedAt" />

      <ClientCompanyCard :client="client" v-if="!client.deletedAt" />

      <ClientGeolocCard :client="client" v-if="!client.deletedAt" />

      <ClientContactInfoCard
        :client="client"
        v-if="!client.deletedAt"
        @edit="edit"
      />

      <ClientGoalsCard :clientData="client" @edit="edit" />

      <ClientInfoAdminCard :client="client" @edit="edit" />
    </div>
  </div>
</template>

<script>
import ClientGlobalCard from "@/components/client/ClientGlobalCard";
import ClientStatusCard from "@/components/client/ClientStatusCard";
import ClientCommercialCard from "@/components/client/ClientCommercialCard";
import ClientGeolocCard from "@/components/client/ClientGeolocCard";
import ClientGoalsCard from "@/components/client/ClientGoalsCard";
import ClientUrssafCard from "@/components/client/ClientUrssafCard";
import ClientCompanyCard from "@/components/client/ClientCompanyCard";
import ClientInfoAdminCard from "@/components/client/ClientInfoAdminCard";
import ClientContactInfoCard from "@/components/client/ClientContactInfoCard";
import ClientAxonautRelation from "@/components/client/ClientAxonautRelation";

export default {
  components: {
    ClientGlobalCard,
    ClientStatusCard,
    ClientCommercialCard,
    ClientGeolocCard,
    ClientGoalsCard,
    ClientUrssafCard,
    ClientCompanyCard,
    ClientInfoAdminCard,
    ClientContactInfoCard,
    ClientAxonautRelation,
  },

  props: {
    client: {
      type: Object,
      required: true,
    },

    groups: {
      type: Array,
      default: () => [],
    },

    commercials: {
      type: Array,
      default: () => [],
    },

    disabledDates: {
      type: Object,
      required: true,
    },
  },

  methods: {
    edit({ name, value }) {
      this.$emit("edit", { name, value });
    },

    editNotes() {
      this.$emit("editNotes");
    },

    reload() {
      this.$emit("reload");
    },

    editOrderDescription(template) {
      this.$emit("editOrderDescription", template);
    },

    deleteOrderDescription(descriptionId) {
      this.$emit("deleteOrderDescription", descriptionId);
    },

    addOrderDescription(template) {
      this.$emit("addOrderDescription", template);
    },
  },
};
</script>
